import config from '../../config';
import { IProduct, IProductPrices } from '../common/interfaces/products.interface';

export default class ProductHelper {
  public static discountOrSoldOutImage(isPartner: boolean, product: IProduct): string {
    if(product.soldOut) {
      return config.products.images.soldOut;
    }
    const percentage = isPartner ? product.prices.partner.discountPercentage : product.prices.customer.discountPercentage;
    const { availableDiscounts } = config.products;

    if(percentage && availableDiscounts.indexOf(percentage) >= 0) {
      // since percentage is included in availableDiscounts it is a valid index of config.products.images
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return config.products.images[percentage];
    }
    return ``;
  }

  public static getPriceUnformatted(isPartner: boolean, prices: IProductPrices): number | string {
    if(!prices || !prices.customer || !prices.customer.brutto) {
      return ``;
    }
    return isPartner ? prices.partner.brutto : prices.customer.brutto;
  }
}
